export default {
    namespaced: true,
    state: {
        filters: {},
        currentProject: null,
        currentCustomer: null,
        updateTotalsFlag: false,
        listView: false,
        refreshComponent: null,
        notRefreshComponent: null,
        doScroll: false,
        scrollDelay: 0,
        displayFormat: 'hours'
    },
    getters: {
        getFilters: state => state.filters,
        getCurrentProject: state => state.currentProject,
        getCurrentCustomer: state => state.currentCustomer,
        getRefreshComponent: state => state.refreshComponent,
        getListView: state => state.listView,
        getDoScroll: state => state.doScroll,
        getScrollDelay: state => state.scrollDelay,
        getDisplayFormat: state => state.displayFormat
    },
    mutations: {
        setFilters(state, filters) {
            state.filters = {};
            state.filters = filters;
        },
        setCurrentProject(state, currentProject) {
            state.currentProject = currentProject;
        },
        setCurrentCustomer(state, currentCustomer) {
            state.currentCustomer = currentCustomer;
        },
        SET_REFRESH_TOTALS(state, targetComponents) {
            state.updateTotalsFlag = !state.updateTotalsFlag
            state.refreshComponent = (targetComponents.refresh) ? targetComponents.refresh : null
            state.notRefreshComponent = (targetComponents.exclude) ? targetComponents.exclude : null
        },
        SET_LIST_VIEW(state, value) {
            state.listView = value
        },
        SET_DO_SCROLL(state, value) {
            state.doScroll = value
        },
        SET_SCROLL_DELAY(state, value) {
            state.scrollDelay = value
        },
        SET_HOURS_TOTALS_FORMAT(state, value) {
            state.totalsDisplayFormat = value
        }
    },
    actions: {}
};
